import { render, staticRenderFns } from "./clients-list.vue?vue&type=template&id=b5f206b0&scoped=true"
import script from "./clients-list.vue?vue&type=script&lang=js"
export * from "./clients-list.vue?vue&type=script&lang=js"
import style0 from "./clients-list.vue?vue&type=style&index=0&id=b5f206b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f206b0",
  null
  
)

export default component.exports